import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Gmail = (props: TIconProps): ReactElement => (
  <svg
    width="23"
    height="18"
    viewBox="0 0 23 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#gmail_clip0_439_72948)">
      <path
        d="M2 17.5H5.5V8.74242L0.5 4.87878V15.9545C0.5 16.8097 1.1725 17.5 2 17.5Z"
        fill="hsl(from hsl(4 79% 56%) h s 54%)"
      />
      <path
        d="M17.5 17.5H21C21.83 17.5 22.5 16.8071 22.5 15.9545V4.87878L17.5 8.74242"
        fill="hsl(from hsl(4 79% 56%) h s 54%)"
      />
      <path
        d="M17.5 2.04544V8.74241L22.5 4.87878V2.81817C22.5 0.906959 20.3825 -0.182586 18.9 0.963626"
        fill="hsl(from hsl(4 79% 56%) h s 76%)"
      />
      <path
        d="M5.5 8.74244V2.04547L11.5 6.68183L17.5 2.04547V8.74244L11.5 13.3788"
        fill="hsl(from hsl(4 79% 56%) h s 50%)"
      />
      <path
        d="M0.5 2.81774V4.87835L5.5 8.74199V2.04502L4.1 0.963199C2.615 -0.183013 0.5 0.906532 0.5 2.81774Z"
        fill="hsl(from hsl(4 79% 56%) h s 37%)"
      />
    </g>
    <defs>
      <clipPath id="gmail_clip0_439_72948">
        <rect
          width="22"
          height="17"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
